import { isNotNil } from "client/Misc/utils";
import { generateQueryString } from "client_legacy/ndaw/urlHelper";

export interface IOwaNavigator {
	emailOverview(options?: { inNewWindow?: boolean; }): void;
	composeEmailInNewWindow(options?: { to?: string; body?: string; }): void;
	emailItem(options: { id: string; inNewWindow?: boolean; }): void;

	composeAppointmentInNewWindow(): void;
	calendarOverview(options?: { inNewWindow?: boolean; }): void;
	appointmentItem(options: { id: string; inNewWindow?: boolean; }): void;

	peopleOverview(options?: { inNewWindow?: boolean; }): void;
}

export function generateUrl(
	baseOwaUrl: string,
	relativePath: string,
	queryParameters?: Record<string, string | undefined>
): string {
	const absolutePath: string = `${baseOwaUrl}/${relativePath}`;
	let queryString: string = "";

	if (isNotNil(queryParameters)) {
		queryString = generateQueryString(queryParameters);

		if (queryString !== "") {
			queryString = "?" + queryString;
		}
	}

	return absolutePath + queryString;
}